/**
 *
 * Возвращает значение поля из сильно вложенной структуры
 *
 * @example getValueInObjectByPath('tkoOperator.name', l.options.item)
 * @param {String} path
 * @param {Object} obj
 * @returns {String|Object|Array}
 */
export function getValueInObjectByPath(path = '', obj = {}) {
  const parts = path.split('.')
  let out = null

  let source = obj
  parts.forEach((p, i) => {
    const isEnd = i === parts.length - 1
    if (isEnd) {
      out = source[p] || ''
    } else {
      source = source[p] || {}
    }
  })
  return out
}
